import { HeaderComponent as Header } from "./header.component";
export default Header;
